import * as React from 'react';
import { Box, Button } from '@mui/material';
import { useStep } from '../Form';
import { useData } from '../Form';

export default function BackAndNextButtons({handleNext}) {
    const {data} = useData()
    const { currentStep, incrementStep, decrementStep, isLastStep } = useStep()
    return(
        <Box sx={{ display: 'flex', justifyContent: currentStep !== 0 ? 'space-between' : 'flex-end', mt: 4 }}>
            {currentStep !== 0 && (
                <Button color="inherit" onClick={decrementStep}>
                    Back
                </Button>
            )}
            {!isLastStep ?
                <Button
                    variant="contained"
                    onClick={handleNext
                    }
                >
                    Next
                </Button> : <></>}
        </Box>
    )
}
